
import { Options, Vue } from "vue-class-component";

@Options({
  props: {
    msg: String,
    image: String,
    sent: Boolean,
  },
})
export default class MessageWrapper extends Vue {
  msg!: string;
  image!: string;
  sent = false;
}
